import { Component, OnInit, isDevMode } from '@angular/core';
import { Ng4SpinnerService } from '../ng4-spinner/ng4-spinner.service';
import { Subscription } from 'rxjs/Subscription';
export class Ng4DefaultSpinnerComponent implements OnInit {
  subscription: Subscription;
  showDefaultSpinner: boolean;
/**
 * @param {?} _ng4SpinnerService
 */
constructor(private _ng4SpinnerService: Ng4SpinnerService) { }
/**
 * @return {?}
 */
ngOnInit() {
    this.showDefaultSpinner = false;
    this.subscription = this._ng4SpinnerService.spinnerSubject
      .subscribe((state: boolean) => {
        this.showDefaultSpinner = state;
      });
  }
/**
 * @return {?}
 */
ngOnDestroy() {
    if (this.subscription.unsubscribe()) {
      this.subscription.unsubscribe();
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'ng4-default-spinner',
  template: `

    <section *ngIf=showDefaultSpinner>
      <div class="spinner">
        <div class="loading">
  
        </div>
      </div>
    </section>
  `,
  styles: [`
    .spinner {
      width: 100%;
      position: fixed;
      /* Stay in place */
      z-index: 100000;
      /* Sit on top */
      left: 0;
      top: 0;
      background-color: black;
      /* Black fallback color */
      background-color: rgba(0, 0, 0, 0.4);
      /* Black w/opacity */
      overflow-x: hidden;
      /* Disable horizontal scroll */
      height: 100%; }

    .loading {
      width: 50px;
      height: 50px;
      border-radius: 30px;
      border-top: 5px solid #53777A;
      border-bottom: 5px solid #C02942;
      -webkit-box-sizing: border-box;
              box-sizing: border-box;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -80px;
      margin-left: -80px;
      animation: loading 1.2s linear infinite;
      -webkit-animation: loading 1.2s linear infinite; }

    @keyframes loading {
      0% {
        -webkit-transform: rotate(0deg);
                transform: rotate(0deg); }
      100% {
        -webkit-transform: rotate(360deg);
                transform: rotate(360deg); } }

    @-webkit-keyframes loading {
      0% {
        -webkit-transform: rotate(0deg); }
      100% {
        -webkit-transform: rotate(360deg); } }
  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Ng4SpinnerService, },
];
}

function Ng4DefaultSpinnerComponent_tsickle_Closure_declarations() {
/** @type {?} */
Ng4DefaultSpinnerComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
Ng4DefaultSpinnerComponent.ctorParameters;
/** @type {?} */
Ng4DefaultSpinnerComponent.prototype.subscription;
/** @type {?} */
Ng4DefaultSpinnerComponent.prototype.showDefaultSpinner;
/** @type {?} */
Ng4DefaultSpinnerComponent.prototype._ng4SpinnerService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
